<template>
  <article class="main app-main">
    <header v-if="showTitle">
      <!-- <h2 class="top-title">隐私声明</h2> -->
      <p>
        <span
          >为使用鲲鹏保险经纪服务平台（“鲲鹏保险经纪平台”）的服务，您应当阅读并遵守《鲲鹏保险经纪平台隐私声明》（以下简称“本隐私声明”）。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >鲲鹏保险经纪平台，是指鲲鹏保险经纪（北京）有限公司（以下简称“鲲鹏保险经纪”）运营的包括但不限于“巴陵e惠保”微信公众号等其他微信公众号、小程序、网页、网站、APP等线上平台。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >鲲鹏保险经纪（或“我们”）非常重视您个人信息的保密和安全，并一直致力于依法保护您的个人信息。鉴此，鲲鹏保险经纪制定了本隐私声明，旨在向您说明：</span
        >
      </p>
      <p>
        <span
          >您在使用鲲鹏保险经纪提供的产品或服务时，鲲鹏保险经纪如何收集、使用、对外提供、转移、保护您的个人信息，以及为您提供管理您个人信息的途径和方法，因此建议您在使用鲲鹏保险经纪所提供的产品或服务前，务必仔细阅读本隐私声明，您需在充分理解并同意本隐私声明后，再使用相关产品或服务。一旦您点击同意本隐私声明，即表示您已充分理解并同意本隐私声明。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>为便于您了解本隐私声明内容，您可以根据以下提纲阅读相应章节:</span>
      </p>
      <p><span>一、定义</span><span>&nbsp;</span></p>
      <p><span>二、适用范围</span><span>&nbsp;</span></p>
      <p><span>三、个人信息的收集、使用</span><span>&nbsp;</span></p>
      <p>
        <span>四、个人信息的对外提供、转移、公开披露、委托处理</span>
      </p>
      <p><span>五、个人信息的存储</span><span>&nbsp;</span></p>
      <p><span>六、个人信息的保护</span><span>&nbsp;</span></p>
      <p>
        <span>七、使用Cookies（网络跟踪器）和同类技术的政策</span
        ><span>&nbsp;</span>
      </p>
      <p><span>八、未成年人隐私权保护</span><span>&nbsp;</span></p>
      <p>
        <span>九、您如何管理您的个人信息</span>
      </p>
      <p><span>十、隐私声明的修订</span><span>&nbsp;</span></p>
      <p>
        <span>十一、如何联系鲲鹏保险经纪</span>
      </p>
      <p><span>一、定义</span><span>&nbsp;</span></p>
      <p>
        <span
          >1．个人信息：以电子或者其他方式记录的
          与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</span
        >
      </p>
      <p>
        <span
          >2．匿名化：是指个人信息经过处理无法识别特定自然人且不能复原的过程。</span
        >
      </p>
      <p><span>二、适用范围</span><span>&nbsp;</span></p>
      <p>
        <span
          >本隐私声明适用于通过鲲鹏保险经纪运营的“巴陵e惠保”微信公众号向您提供的保险产品及相关增值服务。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >特别说明：除鲲鹏保险经纪通过上述平台向您提供的保险产品服务及相关增值服务外，本隐私声明不适用于其他任何第三方单独向您提供的服务。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >三、个人信息的收集、使用鲲鹏保险经纪仅会出于本隐私声明所述的以下目的，收集和使用您的个人信息：</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>（一）鲲鹏保险经纪如何收集您的个人信息</span>
      </p>
      <p>
        <span>1.帮助您成为鲲鹏保险经纪平台的注册用户</span><span>&nbsp;</span>
      </p>
      <p>
        <span
          >成为鲲鹏保险经纪平台的注册用户，您需要提供手机号码进行账户注册并创建密码，或通过您的授权同意以您在第三方（包括微信、QQ、支付宝）注册的账户登录鲲鹏保险经纪平台，我们仅在您授权的范围内接收第三方提供的信息。如果您不提供这类信息，鲲鹏保险经纪将无法为您创建账户。如果您仅需浏览部分页面，您不需要成为鲲鹏保险经纪平台的注册用户。</span
        >
      </p>
      <p>
        <span
          >如您主动注销账号时，鲲鹏保险经纪将及时停止继续收集您个人信息的行为。</span
        >
      </p>

      <p>
        <span>2.帮助您完成实名认证</span>
      </p>
      <p>
        <span
          >为完成实名认证，您需要提供您的姓名、身份证号、手机号码，我们将委托有服务能力的第三方对上述信息进行认证。如果您不提供这类信息，鲲鹏保险经纪将无法为您提供查询保单服务。如果您仅需浏览部分页面，您不需要进行实名认证。</span
        >
      </p>

      <p>
        <span>3.购买保险产品及保单管理</span>
      </p>
      <p>
        <span
          >为向您提供鲲鹏保险经纪的产品或服务，您需要提供您的个人信息或授权鲲鹏保险经纪向合法拥有您信息的第三方收集您的个人信息，实际需要提供或授权收集的个人信息，以您享受的产品或服务所必需的个人信息为限，包括：个人姓名、出生日期、身份证件号码、性别、住址、电话号码、电子邮箱、财务信</span
        ><span
          >息、支付信息、设备信息、日志信息、征信信息、行踪轨迹、个人生物识别信息、个人健康生理信息、基因检测疾病诊断证明。我们仅在您授权的范围内接收第三方提供的信息，如第三方向我们提供的信息超出了您的授权，您可根据本声明提供的联系方式与我们联系，要求我们停止收集、删除您的个人信息。</span
        >
      </p>
      <p>
        <span
          >您提供或授权收集的上述信息可能会用于身份验证、资格审核、信用评估、客户服务、安全防范、诈骗监测、存档、备份，以确保鲲鹏保险经纪向您提供的产品和服务的适当性和安全性。对于您提供的个人信息，鲲鹏保险经纪会按照本声明承诺的标准进行保护。如您不提供前述信息，您将无法购买保险产品。</span
        >
      </p>
      <p>
        <span
          >为展示您投保的保单信息，鲲鹏保险经纪会收集您在使用鲲鹏保险经纪产品或服务过程中产生的保单信息用于向您展示及便于您对保单进行管理。</span
        ><span>&nbsp;</span>
      </p>

      <p>
        <span>4.帮助您完成支付</span>
      </p>
      <p>
        <span
          >为帮助您完成支付，您可以使用第三方所提供的支付服务。为实现支付服务的需要，鲲鹏保险经纪会收集并将您的保单号、交易金额、交易状态信息，以确认您已完成支付。如您不提供前述这些信息，可能将无法使用相关支付功能。</span
        >
      </p>

      <p>
        <span>5.向您展示或推送您可能感兴趣的产品或服务信息</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >为改善鲲鹏保险经纪的保险产品或服务、向您提供个性化的信息搜索及交易服务，鲲鹏保险经纪可能会根据您的日志信息、设备信息、位置信息，提取您的浏览、搜索偏好、行为习惯、地区、微信昵称，向您展示、推送信息。如果您不想接收鲲鹏保险经纪给您推送的信息，您可随时通过相应产品退订功能取消。</span
        ><span>&nbsp;</span>
      </p>

      <p>
        <span>6.供鲲鹏保险经纪统计或精算研究之用</span>
      </p>
      <p>
        <span
          >您使用鲲鹏保险经纪提供的产品或服务时，向鲲鹏保险经纪提供的或授权鲲鹏保险经纪收集的【个人身份信息、个人健康生理信息、理赔信息中的性别、年龄、地域、疾病、医疗诊断、确诊疾病使用的药品或器械、理赔金额及次数】，会用于鲲鹏保险经纪出于自身管理或监管要求的保险统计，以及精算研究。如我们将统计、研究结果用于自动化决策并对您的个人权益造成重大影响的，您有权要求我们作出解释，并要求我们提供人工复核。同时，我们将在进</span
        ><span
          >行自动化决策前进行个人信息保护影响评估，以保障您的个人权益及信息安全。</span
        >
      </p>

      <p><span>7.提供安全保障</span><span>&nbsp;</span></p>
      <p>
        <span
          >为提高您使用本平台及鲲鹏保险经纪合作伙伴所提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、
          计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或监管
          规定的情况，鲲鹏保险经纪可能使用或整合您的注册账户信息、保单信息、理赔信息、设备信息、有关网络日志以及其他第三方取得您授权或依据法律共享的信息，来综合判断您注册账户及理赔风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。除法律另有规定外，我们仅在您授权的范围内接收第三方提供的信息。如您不提供上述信息，则鲲鹏保险经纪无法保证您在使用期间的鲲鹏保险经纪平台运行安全。</span
        >
      </p>

      <p>
        <span>8.联系鲲鹏保险经纪</span>
      </p>
      <p>
        <span
          >当您与鲲鹏保险经纪联系时，鲲鹏保险经纪可能会保存您的姓名、联系方式、留言信息、通信/通话记录，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。如您不提供上述信息，您的建议、反馈可能无法得到及时、有效处理，但不影响您正常使用鲲鹏保险经纪的其他服务。</span
        >
      </p>

      <p>
        <span>（二）设备权限调用情况</span>
      </p>
      <p>
        <span
          >在您使用鲲鹏保险经纪平台过程中，鲲鹏保险经纪需要在必要范围内向您申请获取设备权限。请您知悉，鲲鹏保险经纪不会默认开启您设备的权限，仅在您主动确认开启的情况下，鲲鹏保险经纪平台才有可能通过设备权限收集您的信息。鲲鹏保险经纪平台调用的权限、调用权限的目的，以及调用权限前向您询问的情况请见下表：</span
        >
      </p>
      <div style="text-align:center">
        <table
          cellspacing="0"
          cellpadding="0"
          style="width:100%; margin-right:auto; margin-left:auto; border-collapse:collapse"
        >
          <tbody>
            <tr>
              <td
                style="width:42.75pt; border:0.75pt solid #dddddd; padding:4.88pt 7.12pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span style="font-family:'宋体'; font-weight:bold"
                    >设备权限</span
                  >
                </p>
              </td>
              <td
                style="width:147pt; border-top:0.75pt solid #dddddd; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:4.88pt 7.12pt 4.88pt 7.5pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span style="font-family:'宋体'; font-weight:bold"
                    >调用权限的目的</span
                  >
                </p>
              </td>
              <td
                style="width:93.75pt; border-top:0.75pt solid #dddddd; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:4.88pt 7.12pt 4.88pt 7.5pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span style="font-family:'宋体'; font-weight:bold"
                    >是否询问</span
                  >
                </p>
              </td>
              <td
                style="width:89.25pt; border-top:0.75pt solid #dddddd; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:0.38pt 0.38pt 0.38pt 0.75pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span style="font-family:'宋体'; font-weight:bold"
                    >用户可否关闭权限</span
                  >
                </p>
              </td>
            </tr>
            <tr style="height:14.25pt">
              <td
                style="width:42.75pt; border-right:0.75pt solid #dddddd; border-left:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:5.25pt 7.12pt 4.88pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span>网络</span>
                </p>
              </td>
              <td
                style="width:147pt; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:5.25pt 7.12pt 4.88pt 7.5pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-indent:20.25pt; text-align:center; font-size:10pt"
                >
                  <span>连接网络</span>
                </p>
              </td>
              <td
                style="width:93.75pt; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:5.25pt 7.12pt 4.88pt 7.5pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span>是</span>
                </p>
              </td>
              <td
                style="width:89.25pt; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:0.75pt 0.38pt 0.38pt 0.75pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span>可</span>
                </p>
              </td>
            </tr>
            <tr style="height:17.25pt">
              <td
                style="width:42.75pt; border-right:0.75pt solid #dddddd; border-left:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:5.25pt 7.12pt 4.88pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span style="font-family:'宋体'; font-weight:bold"
                    >位置信息</span
                  >
                </p>
              </td>
              <td
                style="width:147pt; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:5.25pt 7.12pt 4.88pt 7.5pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-indent:20.25pt; text-align:center; font-size:10pt"
                >
                  <span>推送产品或服务</span>
                </p>
              </td>
              <td
                style="width:93.75pt; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:5.25pt 7.12pt 4.88pt 7.5pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span>是</span>
                </p>
              </td>
              <td
                style="width:89.25pt; border-right:0.75pt solid #dddddd; border-bottom:0.75pt solid #dddddd; padding:0.75pt 0.38pt 0.38pt 0.75pt; vertical-align:middle; background-color:#ffffff"
              >
                <p
                  style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10pt"
                >
                  <span>可</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span>8.联系鲲鹏保险经纪</span>
      </p>
      <p>
        <span
          >当您与鲲鹏保险经纪联系时，鲲鹏保险经纪可能会保存您的姓名、联系方式、留言信息、通信/通话记录，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。如您不提供上述信息，您的建议、反馈可能无法得到及时、有效处理，但不影响您正常使用鲲鹏保险经纪的其他服务。</span
        >
      </p>
      <p>
        <span>设备权限调用权限的目的是否询问用户可否关闭权限</span>
      </p>
      <p>
        <span>网络连接网络是可</span>
      </p>
      <p>
        <span>位置信息推送产品或服务是可</span>
      </p>

      <p>
        <span>（二）设备权限调用情况</span>
      </p>
      <p>
        <span
          >在您使用鲲鹏保险经纪平台过程中，鲲鹏保险经纪需要在必要范围内向您申请获取设备权限。请您知悉，鲲鹏保险经纪不会默认开启您设备的权限，仅在您主动确认开启的情况下，鲲鹏保险经纪平台才有可能通过设备权限收集您的信息。鲲鹏保险经纪平台调用的权限、调用权限的目的，以及调用权限前向您询问的情况请见下表：</span
        >
      </p>

      <p>
        <span>（三）鲲鹏保险经纪如何使用您的个人信息</span>
      </p>
      <p>
        <span
          >1．鲲鹏保险经纪会根据本声明的约定并为实现鲲鹏保险经纪的服务的目的对所收集的个人信息进行使用。</span
        ><span>&nbsp;</span>
      </p>

      <p>
        <span
          >2．我们收集的敏感个人信息已在本隐私政策中通过显著标识进行展示；如需获取您单独同意的，我们将在收集前获取您的单独同意。请您知悉，一旦您的敏感个人信息被泄露、篡改或被非法使用，将会对您的人身或财产安全造成损害。为防止您的敏感个人信息被泄露或被非法使用，我们已采取适当的技术和管理保护措施，尽力保障您的个人信息安全。</span
        >
      </p>

      <p>
        <span
          >3．请您注意，您在使用鲲鹏保险经纪提供的服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝鲲鹏保险经纪收集，否则将在您使用鲲鹏保险经</span
        ><span
          >纪的服务期间持续授权鲲鹏保险经纪使用。在您注销账号时，鲲鹏保险经纪将停止使用并删除您的个人信息。</span
        >
      </p>

      <p>
        <span
          >4．鲲鹏保险经纪会对鲲鹏保险经纪提供的服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以用于产品开发、服务优化、安全保障的目的。但这些统计信息不包含您的任何身份识别信息。</span
        ><span>&nbsp;</span>
      </p>

      <p>
        <span
          >5．随着我们的产品与服务的升级迭代，我们可能会对本声明描述的业务功能及对应收集使用的个人信息类型进行调整。当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。当我们要将您的个人信息用于与原处理目的无直接或合理关联的场景，或本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，我们会通过更新本政策、相关产品页面等隐私文档并通过弹窗、站内信、推送信息等多种方式向您告知，并事先征求您的同意；如该信息为敏感个人信息，我们将取得您的单独同意。</span
        >
      </p>

      <p>
        <span>（四）其他规则</span>
      </p>
      <p>
        <span
          >若您提供的信息中含有他人的个人信息，在向鲲鹏保险经纪提供这些个人信息之前，您需要确保您已经取得合法的授权。</span
        >
      </p>
      <p>
        <span
          >当鲲鹏保险经纪要将您的个人信息用于本隐私声明未载明的其他用途，或将基于特定目的收集而来的个人信息用于其他目的时，会事先征求您的同意，但以下情况除外：</span
        >
      </p>
      <p>
        <span>1．为订立、履行您作为一方当事人的合同所必需；</span>
      </p>
      <p>
        <span>2．为履行法定职责或者法定义务所必需；</span>
      </p>
      <p>
        <span
          >3．为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span
        >
      </p>
      <p>
        <span
          >4．为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span
        >
      </p>
      <p>
        <span
          >5．依照本法规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；</span
        >
      </p>
      <p>
        <span>6．法律、行政法规规定的其他情形。</span>
      </p>

      <p>
        <span>四、个人信息的对外提供、转移、公开披露、委托处理</span>
      </p>
      <p><span>（一）对外提供</span><span>&nbsp;</span></p>
      <p>
        <span
          >鲲鹏保险经纪不会与鲲鹏保险经纪以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >1.我们致力于取得和维护您对我们的信任。未经您的单独同意或不具备其他合法事由，我们不会向其他公司、组织或个人提供您的个人信息。如我们因情况变化，需要对外提供您个人信息的，我们会就相关信息对您进行告知并征得您的单独同意。目前，我们的服务中涉及对外提供个人信息的情形包括：</span
        >
      </p>
      <p>
        <span
          >（1）基于您的单独同意或您主动提出要求：如您主动、自愿要求我们向第三方提供您的个人信息的，我们将基于您同意的目的，在相应页面中以适当方式告知您个人信息接收方的名称和联系信息。</span
        >
      </p>
      <p>
        <span
          >（2）我们可能会根据法律法规规定、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行的必需，对外提供您的信息。如我们为履行法定义务而向第三方提供您的个人信息的，我们将在相应页面或通过其他可行方式以适当方式告知您个人信息接收方的名称和联系信息。</span
        >
      </p>
      <p>
        <span
          >（3）为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需，我们向第三方提供您的个人信息的，我们会在适当时机（如紧急情况消除后）向您告知有关信息。</span
        >
      </p>
      <p>
        <span
          >关于我们对外提供个人信息的情况，请查看《巴陵e惠保共享清单》或查看链接http://baoxian72.com/InfoOpen/show.php?id=54：</span
        >
      </p>
      <div style="text-align:center">
        <table
          cellspacing="0"
          cellpadding="0"
          style="margin-right:auto; margin-left:auto; border-collapse:collapse"
        >
          <tbody>
            <tr>
              <td
                style="width:54pt; border-style:solid; border-width:0.75pt; padding-right:4.88pt; padding-left:4.88pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>接收方类型</span>
                </p>
              </td>
              <td
                style="width:69pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>接收方名称</span>
                </p>
              </td>
              <td
                style="width:76.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>接收方联系方式</span>
                </p>
              </td>
              <td
                style="width:60.75pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>对外提供信息字段</span>
                </p>
              </td>
              <td
                style="width:41.25pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>对外提供目的</span>
                </p>
              </td>
              <td
                style="width:50.25pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>对外提供方式</span>
                </p>
              </td>
            </tr>
            <tr>
              <td
                style="width:54pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:4.88pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>保险公司</span>
                </p>
              </td>
              <td
                style="width:69pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>中国人寿保险股份有限公司湖南省分公司</span>
                </p>
              </td>
              <td
                style="width:76.5pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>95519</span>
                </p>
              </td>
              <td
                style="width:60.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:justify; font-size:10.5pt"
                >
                  <span
                    >姓名、身份证号、手机号、联系方式、既往疾病等投保信息</span
                  >
                </p>
              </td>
              <td
                style="width:41.25pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>投保及承保</span>
                </p>
              </td>
              <td
                style="width:50.25pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:4.88pt; padding-left:5.25pt; vertical-align:middle"
              >
                <p
                  style="margin-top:0pt; margin-bottom:3.75pt; text-align:center; font-size:10.5pt"
                >
                  <span>系统对接</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span
          >2.对我们与之提供个人信息的公司、组织和个人，我们会与其签署严格的共享协议，要求接收方按照法律的规定、我们的说明以及本隐私政策的内容处理您的个人信息，要求接收方变更处理目的、处理方式时重新获得您的同意。同时我们会在对外提供您的个人信息前对接受方进行个人信息保护影响评估，以审查接收方的处理目的、处理方式等是否合法、正当、必要，对您个人权益的影响及安全风险，以及接收方是否采取了合法、有效与风险程度相使用的管理措施和技术措施保障个人信息的安全。</span
        >
      </p>

      <p><span>（二）转移</span><span>&nbsp;</span></p>
      <p>
        <span
          >在涉及合并、分立、解散、被宣告破产等原因需要转移您的个人信息时，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。同时，我们会告知您上述主体的名称以及联系方式。</span
        >
      </p>

      <p><span>（三）公开披露</span><span>&nbsp;</span></p>
      <p>
        <span
          >除非本声明另有约定或法律明确规定，鲲鹏保险经纪不会公开披露您的个人信息。</span
        >
      </p>

      <p>
        <span>（四）委托处理</span>
      </p>
      <p>
        <span
          >我们可能会委托第三方服务提供者代表我们处理您的信息，以便第三方服务提供者帮助我们提供专业服务。委托处理行为受本政策中所声明目的约束，并且我们会通过书面协议、审计等方式要求受托机构要求遵守严格的保密义务及采取有效的保密措施，禁止其将受托处理的信息用于受托目的之外的用途。</span
        >
      </p>

      <p>
        <span
          >（五）请注意，您在使用我们服务时自愿对外提供甚至公开分享的信息，可能会涉及您或他人的个人信息甚至敏感个人信息。请您谨慎对外提供或公开，如所涉信息包含他人个人信息，请您在对外提供或公开前取得他人的单独同意。</span
        >
      </p>

      <p>
        <span
          >（六）请知悉，根据法律规定，若我们采取技术措施和其他必要措施处理个人信息，使得数据接收方无法重新识别特定个人且不能复原，经上述处理后的数据的对外提供、公开披露无需另行向您通知并征得您的同意。</span
        >
      </p>

      <p><span>五、个人信息的存储</span><span>&nbsp;</span></p>
      <p>
        <span
          >在中华人民共和国境内收集和产生的个人信息，鲲鹏保险经纪将存储在中华人民共和国境内（不含港、澳、台地区）。</span
        >
      </p>
      <p>
        <span
          >如鲲鹏保险经纪需向境外传输您的个人信息的，则会向您充分告知境外接受方的情况，并征得您的单独同意或依赖其他合法事由，并通过按照国家网信部门会同国务院有关部门制定的办法所要求的安全评估且要求接收方按照鲲鹏保险经纪的说明、本隐私声明以及其他任何相关的保密和安全措施来处理所接受的个人信息。</span
        >
      </p>
      <p>
        <span
          >鲲鹏保险经纪将在实现本隐私声明中所述目的所必需的期间保留您的个人信息，除非法律要求或允许在更长的期间内保留您的个人信息。前述期间届满之后，鲲鹏保险经纪会对您的个人信息删除或匿名化处理。</span
        >
      </p>

      <p>
        <span>六、个人信息的保护</span>
      </p>
      <p>
        <span
          >鲲鹏保险经纪非常重视您的个人信息安全，会采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，并尽最大合理努力使您的个人信息不会被泄露、毁损或者丢失，包括但不限于限制物理访问鲲鹏保险经纪系统内的数据及在转移敏感数据时进行加密处理等。鲲鹏保险经纪对可能接触到您个人信息的员工或外包人员也采取了严格管理，包括但不限于信息访问权限控制、与接触个人信息的人员签署保密协议、监控该等人员的操作情况等措施。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >鲲鹏保险经纪平台的注册账户信息（包括帐户名及密码信息）为非常重要的个人信息，请您妥善设置、保管您的注册账户信息。本平台将通过备份、对密码进行加密等安全措施以保护您的注册帐户信息等个人信息不丢失、不被滥用。</span
        >
      </p>
      <p>
        <span
          >尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。鲲鹏保险经纪亦不对由此产生或与之相关的任何风险、损失承担责任。</span
        >
      </p>
      <p>
        <span
          >在不幸发生个人信息安全事件后，鲲鹏保险经纪将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、鲲鹏保险经纪已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。鲲鹏保</span
        ><span
          >险经纪将及时将事件相关情况以应用程序推送、电子邮件、短信、电话等方式告知您，难以逐一告知个人信息主体时，鲲鹏保险经纪会采取合理、有效的方式发布公告。同时，鲲鹏保险经纪还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span
        >
      </p>

      <p>
        <span>七、使用 Cookies（网络跟踪器）和同类技术的政策</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >为使您获得更为轻松的访问体验，您访问鲲鹏保险经纪平台或使用鲲鹏保险经纪提供的产品或服务，鲲鹏保险经纪可能会通过采用各种技术收集和存储相关信息，包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入注册信息的步骤，或者帮助判断您的帐户安全。这些数据可能是
          Cookies、Flash
          Cookies，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookies”）。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >第三方合作伙伴通过Cookies收集和使用您的信息不受本声明约束，而是受到其自身的信息保护声明约束，鲲鹏保险经纪不对第三方的Cookies或同类技术承担责任。</span
        >
      </p>
      <p>
        <span
          >请您理解，鲲鹏保险经纪的某些服务需要通过使用Cookies才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对
          Cookies 的接受程度或者拒绝鲲鹏保险经纪平台的
          Cookies，但如拒绝，在某些情况下可能会影响您安全访问鲲鹏保险经纪平台。同时，您仍然将收到商品或服务信息，只是这些商品或服务信息与您的相关性会降低。</span
        >
      </p>

      <p><span>八、未成年人隐私权保护</span><span>&nbsp;</span></p>
      <p>
        <span
          >鲲鹏保险经纪重视未成年人的信息保护，我们设置有专门的个人信息处理规则，并设置有专门的儿童个人信息保护负责人保护儿童个人信息。</span
        >
      </p>
      <p>
        <span
          >如您是已满14周岁未满18周岁的未成年人，应首先取得其监护人的同意，在监护人同意后和指导下进行使用、提交个人信息。</span
        >
      </p>
      <p>
        <span
          >如果您是14周岁以下未成年人的，请您在使用我们的产品与服务前，通知您的监护人仔细阅读我们的《小鱼惠保儿童个人信息保护规则》，并请您的监护人的同意后，在监护人的指导下使用我们的产品与服务。</span
        >
      </p>
      <p>
        <span
          >如您是未成年人的监护人，请您关注您所监护的未成年人是否是在您同意之后使用我们的产品与服务。如果您对您所监护的未成年人的个人信息有疑问，请通过本声明或《小鱼惠保儿童个人信息保护规则》载明的方式与我们联系。</span
        >
      </p>

      <p><span>九、您如何管理您的个人信息</span><span>&nbsp;</span></p>

      <p>
        <span
          >按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</span
        ><span>&nbsp;</span>
      </p>
      <p><span>（一）查询、复制您的个人信息</span><span>&nbsp;</span></p>
      <p>
        <span
          >您有权查询、复制您的个人信息，可通过“【我的】-【我的保单】-【我的】-【点击头像】”查询或复制您的个人信息，同时您也可以根据本声明载明的联系方式与我们联系查询或复制您的个人信息。在符合相关法律规定的前提下，我们将在合理的期限内，通过适当的方式向您提供可复制的个人信息副本。</span
        >
      </p>

      <p><span>（二）更正、补充您的个人信息</span><span>&nbsp;</span></p>
      <p>
        <span
          >当您发现我们处理的关于您的个人信息有错误或不完整时，您有权要求我们做出更正或补充。您可以通过本声明载明的联系方式与我们联系。</span
        ><span>&nbsp;</span>
      </p>

      <p><span>（三）删除您的个人信息</span><span>&nbsp;</span></p>
      <p>
        <span>在以下情形中，您可以向我们提出删除个人信息的请求：</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>1、如果我们处理个人信息的行为违反法律法规；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>2、基于同意处理您的个人信息，您撤回同意的；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>3、如果我们处理个人信息的行为违反了与您的约定；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >4、如果我们的处理目的已经实现，无法实现或者为实现处理目的不再必要使用您的个人信息；</span
        >
      </p>
      <p>
        <span>5、如果您不再使用我们的产品或服务，或您注销了账号；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>6、如果我们不再为您提供产品或服务，或保存期限已经届满；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>7、法律法规规定的其他情形。</span>
      </p>
      <p>
        <span
          >若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >如果您想行使数据删除权，可通过本声明载明的联系方式与我们联系。</span
        ><span>&nbsp;</span>
      </p>

      <p><span>（四）改变您授权同意的范围</span><span>&nbsp;</span></p>
      <p>
        <span
          >每个业务功能需要一些基本的个人信息才能得以完成，对于额外收集的个人信息的收集和使用，您可以随时给予或撤回您的授权同意您可通过本声明载明提供的联系方式与我们联系进行授权变更。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >请您理解，鲲鹏保险经纪可能需要开启部分权限并收集必要的个人信息才能得以实现。当您撤回您的同意时，我们将无法继续为您提供撤回同意所对应的服务，但不会影响此前基于您的授权而开展的个人信息处理服务。</span
        >
      </p>

      <p>
        <span>（五）转移您的个人信息</span>
      </p>
      <p>
        <span
          >若您需要将您的个人信息转移至其他平台、企业或组织，您可以通过本声明载明的联系方式与我们联系。我们将对您的请求进行审核，在符合网信部门规定的条件下，我们将为您提供转移相应个人信息的途径。</span
        >
      </p>

      <p><span>（六）注销账户</span><span>&nbsp;</span></p>
      <p>
        <span
          >如果您希望注销您的账户，您可以通过本声明载明的方式与我们联系，我们将及时响应您的请求。</span
        >
      </p>
      <p>
        <span
          >您注销上述账户的行为是不可逆的，我们将停止为您提供产品或服务，不再收集您的个人信息，并依据您的要求删除与您账户相关的个人信息或做匿名化处理。</span
        >
      </p>

      <p>
        <span>（七）解释说明权</span>
      </p>
      <p>
        <span
          >如您对我们的个人信息规则存在疑问，您可以通过本声明载明的联系方式与我们联系，我们会对有关个人信息处理规则向您进行解释说明。</span
        >
      </p>

      <p>
        <span>（八）限制或拒绝处理权</span>
      </p>
      <p>
        <span
          >在符合法律规定的前提下，您有权限制或者拒绝我们对您的个人信息进行处理。如您想要行使该权利，您可以通过本声明载明的联系方式与我们联系，我们会在收到您的请求后尽快处理回复。</span
        >
      </p>

      <p>
        <span>（九）特殊情况下对您的近亲属请求的响应</span>
      </p>
      <p>
        <span
          >根据法律规定，我们建立有去世用户的个人信息保护制度。去世用户的近亲属为了其自身的合法、正当利益，可以根据本政策提供的联系方式与我们联系，并对去世用户的相关个人信息行使本规则规定的查阅、复制、更正、补充、删除等权利。在响应去世用户近亲属的请求，我们将通过严格的流程对其身份和行权目的进行审核。为了充分保护去世用户的个人信息权益，申请行使本条权利的去世用户近亲属需要根据我们的要求提交相应材料，包括：【信息类型，例如：去世用户的身份证明文件、死亡证明文件、申请人的身份证明文件、申请人与去世用户的亲属关系证明文件、申请行使的权利种类及目的。】</span
        >
      </p>
      <p>
        <span
          >如您不同意您的近亲属在您去世后处理您的个人信息，您可以根据本声明载明的联系方式与我们联系，来说明您的安排。</span
        >
      </p>

      <p><span>（十）响应您的上述请求</span><span>&nbsp;</span></p>
      <p>
        <span
          >为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在十五天内做出答复。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >对于您合理的请求，我们原则上不收取费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>在以下情形中，我们将无法响应您的请求：</span><span>&nbsp;</span>
      </p>
      <p>
        <span>1.与我们履行法律法规规定的义务相关的；</span><span>&nbsp;</span>
      </p>
      <p><span>2.与国家安全、国防安全直接相关的；</span><span>&nbsp;</span></p>
      <p>
        <span>3.与公共安全、公共卫生、重大公共利益直接相关的；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>4.与刑事侦查、起诉、审判和执行判决等直接相关的；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>5.我们有充分证据表明用户存在主观恶意或滥用权利的；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >6.出于维护用户或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span
          >7.响应用户的请求将导致用户或其他个人、组织的合法权益受到严重损害的；</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>8.涉及商业秘密的。</span>
      </p>

      <p><span>十、隐私声明的修订</span><span>&nbsp;</span></p>
      <p>
        <span
          >鲲鹏保险经纪可能适时修订本隐私声明，一旦本隐私声明内容发生变更，鲲鹏保险经纪会于鲲鹏保险经纪平台公布最新的隐私声明，并通过显著的方式通知您。未经您明确同意，鲲鹏保险经纪不会削减您按照本隐私政策所应享有的权利。</span
        >
      </p>
      <p>
        <span
          >若您在本隐私声明修订后继续使用鲲鹏保险经纪提供的产品或服务，这表示您已充分阅读、理解并愿意受修订后的隐私声明约束。</span
        >
      </p>
      <p>
        <span>鲲鹏保险经纪还会将本隐私政策的旧版本存档，供您查阅。</span>
      </p>

      <p>
        <span>十一、如何联系鲲鹏保险经纪</span>
      </p>
      <p>
        <span
          >如果您对本政策或个人信息保护有任何问题，您可以将您的书面疑问、意见或建议通过以下地址寄至客服部门：</span
        >
      </p>
      <p>
        <span>名称：鲲鹏保险经纪（北京）有限公司</span>
      </p>
      <p>
        <span>地址：北京市丰台区益泽路8号院1号楼13层1302</span
        ><span>&nbsp;</span>
      </p>
      <p>
        <span>或您也可以通过以下电话与客服部门进行联系：</span>
      </p>
      <p><span>联系电话：</span><span>&nbsp;</span><span>400-001-6600</span></p>
      <p>
        <span
          >一般情况下，鲲鹏保险经纪将在十五日内回复。如果您对鲲鹏保险经纪的回复不满意，特别是鲲鹏保险经纪的个人信息处理行为损害了您的合法权益，且在您反馈后我们仍拒绝改进的，您还可以向网信、工信、公安及工商等监管部门进行投诉或举报，或通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案，或通过向被告住所地有管辖权的法院提起诉讼来寻求解决。</span
        >
      </p>

      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt"
      >
        <span style="font-family:DengXian">&nbsp;</span>
      </p>
    </header>
  </article>
</template>

<script>
  export default {
    name: 'PrivacyStatement',
    components: {},
    mixins: [],
    props: {
      showTitle: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {}
    },

    computed: {},

    watch: {},

    created() {},

    mounted() {},

    destroyed() {},

    methods: {
      goPart(id) {
        document.getElementById(id).scrollIntoView()
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    padding: px2rem(15, 375);
    color: #333;
    padding-top: 0;
  }

  .top-title {
    text-align: center;
    font-size: px2rem(20, 375);
    margin-bottom: px2rem(20, 375);
  }

  section {
    line-height: 1.5;
  }

  .part-title {
    font-size: px2rem(14, 375);
    font-weight: bold;
    margin-bottom: px2rem(5, 375);
  }

  .user {
    font-weight: normal;
  }

  .clause-block {
    margin-bottom: px2rem(10, 375);
  }

  .part-content {
    font-size: px2rem(14, 375);
    text-indent: px2rem(28, 375);
    text-align: justify;
  }

  .nav-part {
    padding: 0 px2rem(28, 375);
    font-size: px2rem(14, 375);
    line-height: 2;
    a {
      text-decoration: underline;
    }
  }
</style>
